
'use strict';

module.exports = {
    'E2BIG': 7,
    'EACCES': 13,
    'EADDRINUSE': 100,
    'EADDRNOTAVAIL': 101,
    'EAFNOSUPPORT': 102,
    'EAGAIN': 11,
    'EALREADY': 103,
    'EBADF': 9,
    'EBADMSG': 104,
    'EBUSY': 16,
    'ECANCELED': 105,
    'ECHILD': 10,
    'ECONNABORTED': 106,
    'ECONNREFUSED': 107,
    'ECONNRESET': 108,
    'EDEADLK': 36,
    'EDESTADDRREQ': 109,
    'EDOM': 33,
    'EEXIST': 17,
    'EFAULT': 14,
    'EFBIG': 27,
    'EHOSTUNREACH': 110,
    'EIDRM': 111,
    'EILSEQ': 42,
    'EINPROGRESS': 112,
    'EINTR': 4,
    'EINVAL': 22,
    'EIO': 5,
    'EISCONN': 113,
    'EISDIR': 21,
    'ELOOP': 114,
    'EMFILE': 24,
    'EMLINK': 31,
    'EMSGSIZE': 115,
    'ENAMETOOLONG': 38,
    'ENETDOWN': 116,
    'ENETRESET': 117,
    'ENETUNREACH': 118,
    'ENFILE': 23,
    'ENOBUFS': 119,
    'ENODATA': 120,
    'ENODEV': 19,
    'ENOENT': 2,
    'ENOEXEC': 8,
    'ENOLCK': 39,
    'ENOLINK': 121,
    'ENOMEM': 12,
    'ENOMSG': 122,
    'ENOPROTOOPT': 123,
    'ENOSPC': 28,
    'ENOSR': 124,
    'ENOSTR': 125,
    'ENOSYS': 40,
    'ENOTCONN': 126,
    'ENOTDIR': 20,
    'ENOTEMPTY': 41,
    'ENOTSOCK': 128,
    'ENOTSUP': 129,
    'ENOTTY': 25,
    'ENXIO': 6,
    'EOPNOTSUPP': 130,
    'EOVERFLOW': 132,
    'EPERM': 1,
    'EPIPE': 32,
    'EPROTO': 134,
    'EPROTONOSUPPORT': 135,
    'EPROTOTYPE': 136,
    'ERANGE': 34,
    'EROFS': 30,
    'ESPIPE': 29,
    'ESRCH': 3,
    'ETIME': 137,
    'ETIMEDOUT': 138,
    'ETXTBSY': 139,
    'EWOULDBLOCK': 140,
    'EXDEV': 18,
    'WSAEINTR': 10004,
    'WSAEBADF': 10009,
    'WSAEACCES': 10013,
    'WSAEFAULT': 10014,
    'WSAEINVAL': 10022,
    'WSAEMFILE': 10024,
    'WSAEWOULDBLOCK': 10035,
    'WSAEINPROGRESS': 10036,
    'WSAEALREADY': 10037,
    'WSAENOTSOCK': 10038,
    'WSAEDESTADDRREQ': 10039,
    'WSAEMSGSIZE': 10040,
    'WSAEPROTOTYPE': 10041,
    'WSAENOPROTOOPT': 10042,
    'WSAEPROTONOSUPPORT': 10043,
    'WSAESOCKTNOSUPPORT': 10044,
    'WSAEOPNOTSUPP': 10045,
    'WSAEPFNOSUPPORT': 10046,
    'WSAEAFNOSUPPORT': 10047,
    'WSAEADDRINUSE': 10048,
    'WSAEADDRNOTAVAIL': 10049,
    'WSAENETDOWN': 10050,
    'WSAENETUNREACH': 10051,
    'WSAENETRESET': 10052,
    'WSAECONNABORTED': 10053,
    'WSAECONNRESET': 10054,
    'WSAENOBUFS': 10055,
    'WSAEISCONN': 10056,
    'WSAENOTCONN': 10057,
    'WSAESHUTDOWN': 10058,
    'WSAETOOMANYREFS': 10059,
    'WSAETIMEDOUT': 10060,
    'WSAECONNREFUSED': 10061,
    'WSAELOOP': 10062,
    'WSAENAMETOOLONG': 10063,
    'WSAEHOSTDOWN': 10064,
    'WSAEHOSTUNREACH': 10065,
    'WSAENOTEMPTY': 10066,
    'WSAEPROCLIM': 10067,
    'WSAEUSERS': 10068,
    'WSAEDQUOT': 10069,
    'WSAESTALE': 10070,
    'WSAEREMOTE': 10071,
    'WSASYSNOTREADY': 10091,
    'WSAVERNOTSUPPORTED': 10092,
    'WSANOTINITIALISED': 10093,
    'WSAEDISCON': 10101,
    'WSAENOMORE': 10102,
    'WSAECANCELLED': 10103,
    'WSAEINVALIDPROCTABLE': 10104,
    'WSAEINVALIDPROVIDER': 10105,
    'WSAEPROVIDERFAILEDINIT': 10106,
    'WSASYSCALLFAILURE': 10107,
    'WSASERVICE_NOT_FOUND': 10108,
    'WSATYPE_NOT_FOUND': 10109,
    'WSA_E_NO_MORE': 10110,
    'WSA_E_CANCELLED': 10111,
    'WSAEREFUSED': 10112,
    'PRIORITY_LOW': 19,
    'PRIORITY_BELOW_NORMAL': 10,
    'PRIORITY_NORMAL': 0,
    'PRIORITY_ABOVE_NORMAL': -7,
    'PRIORITY_HIGH': -14,
    'PRIORITY_HIGHEST': -20,
    'SIGHUP': 1,
    'SIGINT': 2,
    'SIGQUIT': 3,
    'SIGILL': 4,
    'SIGABRT': 22,
    'SIGFPE': 8,
    'SIGKILL': 9,
    'SIGSEGV': 11,
    'SIGTERM': 15,
    'SIGBREAK': 21,
    'SIGWINCH': 28,
    'UV_FS_SYMLINK_DIR': 1,
    'UV_FS_SYMLINK_JUNCTION': 2,
    'O_RDONLY': 0,
    'O_WRONLY': 1,
    'O_RDWR': 2,
    'UV_DIRENT_UNKNOWN': 0,
    'UV_DIRENT_FILE': 1,
    'UV_DIRENT_DIR': 2,
    'UV_DIRENT_LINK': 3,
    'UV_DIRENT_FIFO': 4,
    'UV_DIRENT_SOCKET': 5,
    'UV_DIRENT_CHAR': 6,
    'UV_DIRENT_BLOCK': 7,
    'S_IFMT': 61440,
    'S_IFREG': 32768,
    'S_IFDIR': 16384,
    'S_IFCHR': 8192,
    'S_IFIFO': 4096,
    'S_IFLNK': 40960,
    'O_CREAT': 256,
    'O_EXCL': 1024,
    'UV_FS_O_FILEMAP': 536870912,
    'O_TRUNC': 512,
    'O_APPEND': 8,
    'S_IRUSR': 256,
    'S_IWUSR': 128,
    'F_OK': 0,
    'R_OK': 4,
    'W_OK': 2,
    'X_OK': 1,
    'UV_FS_COPYFILE_EXCL': 1,
    'COPYFILE_EXCL': 1,
    'UV_FS_COPYFILE_FICLONE': 2,
    'COPYFILE_FICLONE': 2,
    'UV_FS_COPYFILE_FICLONE_FORCE': 4,
    'COPYFILE_FICLONE_FORCE': 4,
    'OPENSSL_VERSION_NUMBER': 805306528,
    'SSL_OP_ALL': 2147485776,
    'SSL_OP_ALLOW_NO_DHE_KEX': 1024,
    'SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION': 262144,
    'SSL_OP_CIPHER_SERVER_PREFERENCE': 4194304,
    'SSL_OP_CISCO_ANYCONNECT': 32768,
    'SSL_OP_COOKIE_EXCHANGE': 8192,
    'SSL_OP_CRYPTOPRO_TLSEXT_BUG': 2147483648,
    'SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS': 2048,
    'SSL_OP_LEGACY_SERVER_CONNECT': 4,
    'SSL_OP_NO_COMPRESSION': 131072,
    'SSL_OP_NO_ENCRYPT_THEN_MAC': 524288,
    'SSL_OP_NO_QUERY_MTU': 4096,
    'SSL_OP_NO_RENEGOTIATION': 1073741824,
    'SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION': 65536,
    'SSL_OP_NO_SSLv2': 0,
    'SSL_OP_NO_SSLv3': 33554432,
    'SSL_OP_NO_TICKET': 16384,
    'SSL_OP_NO_TLSv1': 67108864,
    'SSL_OP_NO_TLSv1_1': 268435456,
    'SSL_OP_NO_TLSv1_2': 134217728,
    'SSL_OP_NO_TLSv1_3': 536870912,
    'SSL_OP_PRIORITIZE_CHACHA': 2097152,
    'SSL_OP_TLS_ROLLBACK_BUG': 8388608,
    'ENGINE_METHOD_RSA': 1,
    'ENGINE_METHOD_DSA': 2,
    'ENGINE_METHOD_DH': 4,
    'ENGINE_METHOD_RAND': 8,
    'ENGINE_METHOD_EC': 2048,
    'ENGINE_METHOD_CIPHERS': 64,
    'ENGINE_METHOD_DIGESTS': 128,
    'ENGINE_METHOD_PKEY_METHS': 512,
    'ENGINE_METHOD_PKEY_ASN1_METHS': 1024,
    'ENGINE_METHOD_ALL': 65535,
    'ENGINE_METHOD_NONE': 0,
    'DH_CHECK_P_NOT_SAFE_PRIME': 2,
    'DH_CHECK_P_NOT_PRIME': 1,
    'DH_UNABLE_TO_CHECK_GENERATOR': 4,
    'DH_NOT_SUITABLE_GENERATOR': 8,
    'RSA_PKCS1_PADDING': 1,
    'RSA_NO_PADDING': 3,
    'RSA_PKCS1_OAEP_PADDING': 4,
    'RSA_X931_PADDING': 5,
    'RSA_PKCS1_PSS_PADDING': 6,
    'RSA_PSS_SALTLEN_DIGEST': -1,
    'RSA_PSS_SALTLEN_MAX_SIGN': -2,
    'RSA_PSS_SALTLEN_AUTO': -2,
    'defaultCoreCipherList': 'TLS_AES_256_GCM_SHA384:TLS_CHACHA20_POLY1305_SHA256:TLS_AES_128_GCM_SHA256:ECDHE-RSA-AES128-GCM-SHA256:ECDHE-ECDSA-AES128-GCM-SHA256:ECDHE-RSA-AES256-GCM-SHA384:ECDHE-ECDSA-AES256-GCM-SHA384:DHE-RSA-AES128-GCM-SHA256:ECDHE-RSA-AES128-SHA256:DHE-RSA-AES128-SHA256:ECDHE-RSA-AES256-SHA384:DHE-RSA-AES256-SHA384:ECDHE-RSA-AES256-SHA256:DHE-RSA-AES256-SHA256:HIGH:!aNULL:!eNULL:!EXPORT:!DES:!RC4:!MD5:!PSK:!SRP:!CAMELLIA',
    'TLS1_VERSION': 769,
    'TLS1_1_VERSION': 770,
    'TLS1_2_VERSION': 771,
    'TLS1_3_VERSION': 772,
    'POINT_CONVERSION_COMPRESSED': 2,
    'POINT_CONVERSION_UNCOMPRESSED': 4,
    'POINT_CONVERSION_HYBRID': 6
};

